import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-alerts-details',
  templateUrl: './alerts-details.component.html',
  styleUrls: ['./alerts-details.component.scss']
})
export class AlertsDetailsComponent implements OnInit {

    productId: string | null = null;
  employee: any = {
    name: '',
    email: '',
    phone: '',
    password: '',
    job_title_id: ''
  };

   employeeId: string | null = null;
  currentLang: string;
notification: any = null;

constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService
  ) {}
    ngOnInit(): void {
    this.currentLang = localStorage.getItem('currentLang') || 'ar';

    // get product id from route
   this.employeeId = this.route.snapshot.paramMap.get('id');
    if (this.employeeId) {
      this.loadNotification(this.employeeId);
    }


        
  }

getInvestorStatusClass(status: string): string {
    if (!status) return 'inactive';
    
    const statusMap: { [key: string]: string } = {
        'active': 'active',
        'نشط': 'active',
        'مكتمل': 'completed',
        'completed': 'completed',
        'معلق': 'pending',
        'pending': 'pending',
        'غير نشط': 'inactive',
        'inactive': 'inactive',
        'غيرنشط': 'inactive'
    };
    
    return statusMap[status.toLowerCase()] || 'inactive';
}
viewInvestorDetails(investorId: number): void {
    // التنقل إلى صفحة تفاصيل المستثمر
    this.router.navigate(['/investors-details', investorId]);
    // أو فتح modal مع التفاصيل
    // this.openInvestorModal(investorId);
}
addInvestor(){
 this.router.navigate(['/add-investors']);

}
  
loadNotification(id: string): void {
  this.apiService.getNotificationsById(id).subscribe({
    next: (res: any) => {
      console.log("NOTIFICATION:", res);
      this.notification = res?.data; // << perfect
    },
    error: (err) => {
      this.toastr.error('Failed to load notification details');
    }
  });
}
}
